export default __webpack_public_path__ + "static/media/composite-thumbnail.e660b28c.png";